import { grey } from './grey';

export const text = {
  primary: grey[800],
  secondary: grey[600],
  disabled: grey[600],
  hint: grey[500],
  contrast: grey[50],
  dark: grey[900],
};
